import React from 'react';
import useNotification from 'hooks/useNotification';
import { Button } from '@mui/material';

interface Props {
  id: string;
  accept?: string;
  buttonLabel: string;
  multiple?: boolean;
  maxSize?: number;
  disabled?: boolean;
  onChange: (files: Array<File>) => void;
}
const Uploader = React.forwardRef((props: Props, ref: any) => {
  const { onFail } = useNotification();
  const {
    id,
    accept,
    buttonLabel,
    multiple = false,
    maxSize = 5,
    disabled,
    onChange,
  } = props;

  return (
    <div className="btn-wrapper">
      <input
        ref={ref}
        accept={accept}
        type="file"
        id={id}
        style={{ display: 'none' }}
        multiple={multiple}
        disabled={disabled}
        onClick={e => {
          e.stopPropagation();
          const element = e.target as HTMLInputElement;
          element.value = '';
        }}
        onChange={e => {
          e.preventDefault();
          e.stopPropagation();
          if (e.target.files) {
            const fileList = e.target.files;
            let result: Array<File> = [];

            for (let i = 0; i < fileList.length; i++) {
              const file = fileList.item(i);
              if (!file) {
                onFail('파일 업로드를 실패하였습니다', '알 수 없음');
                continue;
              }
              // 용량 제한
              if (file.size > maxSize * 1024 * 1024) {
                onFail(
                  '파일 업로드를 실패하였습니다',
                  `업로드 가능한 용량을 초과하였습니다.(최대 ${maxSize}MB)`
                );
                continue;
              }
              result = result.concat(file);
            }
            onChange(result);
          }
        }}
      />
      <Button fullWidth variant="outlined" component="label" htmlFor={props.id}>
        {buttonLabel}
      </Button>
    </div>
  );
});

export default Uploader;
